import { TurretActor } from "./TurretActor";
import { GameVars } from "../../../GameVars";
import { EnemyActor } from "../enemy-actors/EnemyActor";
import * as Anuto from "../../../../engine/src";

export class BzztTurretActor extends TurretActor {

    private framesDuration: number;
    private f: number;
    private laserShoot: boolean;

    constructor(scene: Phaser.Scene, position: {r: number, c: number}, turret: Anuto.Turret) {

        super(scene, Anuto.GameConstants.TURRET_BZZT, position, turret, "texture_atlas_2", true);

        this.anutoTurret = turret;

        this.base.setFrame("torre_4_" + turret.level + "_01");
        this.base.setOrigin(.5, .75);
        this.base.anims.play("torre_4_" + turret.level);

        this.canonLength = 0;
        this.cannon.alpha = 0;

        this.laserShoot = false;
    }

    public upgrade(): void {

        super.upgrade();

        this.base.setFrame("torre_4_" + this.anutoTurret.level + "_01");
        this.base.anims.play("torre_4_" + this.anutoTurret.level);
    }

    public update(time: number, delta: number): void {

        if (this.laserShoot) {
            if (this.f ++ === this.framesDuration) {
                this.laserShoot = false;
            }
            return;
        }

        super.update(time, delta);
    }

    public shootLaser(enemyActors: EnemyActor[]): void {

        const dx = enemyActors[0].x - this.x;
        const dy = enemyActors[0].y - this.y;

        this.cannon.rotation = Math.atan2(dy, dx) + Math.PI / 2;

        this.laserShoot = true;
        this.framesDuration = GameVars.timeStepFactor === 1 ? 24 : 6;
        this.f = 0;

        let flare = new Phaser.GameObjects.Image(this.scene, 0, -45, "texture_atlas_1", "flare_blue");
        flare.alpha = 0;
        flare.setScale(0);
        this.add(flare);

        this.scene.tweens.add({
            targets: flare,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 100 : 25,
            onComplete: () => {
                flare.destroy();
            },
            onCompleteScope: this
        });
    }
}
